<template>
    <div class="social-network">
        <div class="item" v-for="(item,index) in list" :key="index">
            <a :href="item.link" class="item-a" target="_blank">
                <icon-linkedin v-if="item.icon == 'linkedin'" class="icon" />
                <icon-facebook v-if="item.icon == 'facebook'" class="icon" />
                <icon-twitter v-if="item.icon == 'twitter'" class="icon" />
                <icon-instagram v-if="item.icon == 'instagram'" class="icon" />
                <icon-link v-if="item.icon == 'link'" class="icon" />
            </a>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import IconFacebook from '@/components/Icons/Facebook.vue'
import IconLinkedin from '@/components/Icons/Linkedin.vue'
import IconTwitter from '@/components/Icons/Twitter.vue'
import IconInstagram from '@/components/Icons/Instagram.vue'
import IconLink from '@/components/Icons/Link.vue'

export default {
    name: 'social-media',
    props: {
        list: {
            type: Array,
            required: true
        }
    },
    components: {
        IconFacebook,
        IconLinkedin,
        IconTwitter,
        IconInstagram,
        IconLink
    }
}
</script>
